import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import saveAs from 'file-saver';

@Component({
  selector: 'app-insert-vendor-associate',
  templateUrl: './insert-vendor-associate.component.html',
  styleUrls: ['./insert-vendor-associate.component.scss']
})
export class InsertVendorAssociateComponent implements OnInit {

  public vendorAssDetailsForm: FormGroup;
  public userId: any = null;
  public workTypeList: any;
  public isSubmitted: boolean = false;
  public ipAddress: any = '000.000.000';
  public vendorRegId: any = null;

  public addedAssList: any = [];

  menuItems: MenuItem[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];

  constructor(
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _personalDetalSer: FarmersDetailsService,
    private ipService: IpAddressService,
    private fb: FormBuilder,
    // private fApplicationService: FarmersApplicationService,
    private vendorService: VendorDashboardService,
    // private jeService: JEService,
    private cryptoJsService: CryptoJsService,
    // private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    this.vendorRegId = JSON.stringify(token?.officeCode);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loadWorkTypeList();
    this.getIP();
    this.loadAddedAssList();

    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.addedAssList, "Added Vendor Associate List");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.addedAssList, "Added Vendor Associate List");
        }
      },
    ];


    this.vendorAssDetailsForm = this.fb.group({
      associateName: ['', [Validators.required]],
      aadharNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{12}$/)
        ]
      ],
      signature: [null],
      photo: [null],
      mobileNo: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{10}$/)
        ]
      ],
      workType: ['', [Validators.required]],
    });

  }

  loadWorkTypeList() {
    this.loader.start();
    this.vendorService
      .getAssociateWorkType()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          if (res.length > 0) {
            this.workTypeList = res;

            this.vendorAssDetailsForm.reset();

          } else {
            this.workTypeList = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
        },
        error: (err) => {
          this.workTypeList = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }


  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    this._personalDetalSer.uploadNewRegFile(data, this.userId, formcontrol).subscribe(
      (resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          this.vendorAssDetailsForm.patchValue({ [formcontrol]: resp.data });

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `${formcontrol} Uploaded Successfully`,
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Oops! Someting went wrong.',
          });
        }
      },
      (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    );
    uploadElement.clear();
  }


  addVendorAssociate() {
    this.isSubmitted = true;
    if (this.vendorAssDetailsForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning Message',
        detail: 'Fill all the details properly and upload the document',
      });
    }

    if (this.vendorAssDetailsForm.valid) {
      const val = this.vendorAssDetailsForm.value;

      if (val?.signature == null || val?.photo == null) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning Message',
          detail: 'Upload the Photo and Signature.',
        });
        return;
      }

      let reqBody = {
        VendorId: Number(this.vendorRegId),
        Name: val?.associateName,
        AadharNo: String(val?.aadharNumber),
        Mobile: String(val?.mobileNo),
        Signature: val?.signature,
        Photo: val?.photo,
        WorkType: val?.workType?.Id,
        NetworkId: this.ipAddress,
        TerminalID: this.ipAddress
      }

      this.submitAssociateData(reqBody);

    }
  }

  submitAssociateData(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .insertVendorAssociates(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          if (res == 'Associate inserted successfully.') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Details submitted successfully.',
            });

            this.vendorAssDetailsForm.reset();
            this.loadAddedAssList();
            // this.uploadedAadharFiles = [];
            // this.addedLandData = [];
            // this.selectedOutlet = null;
            // this.agreementNo = null;
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
          this.activityRecordService.activityRecord(this.userId, 'Add Associate Data', this.userId, new Date(), `${res}`, JSON.stringify(reqBodyFinal));
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'Add Associate Data(Error)', this.userId, new Date(), `${err}`, JSON.stringify(reqBodyFinal));
        },
      });
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  loadAddedAssList() {
    this.loader.start();
    this.vendorService
      .getAssociatesByVendorId(this.vendorRegId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          if (res.length > 0) {
            this.addedAssList = res;
          } else {
            this.addedAssList = [];
            // this.messageService.add({
            //   severity: 'info',
            //   summary: 'Info Message',
            //   detail: res,
            // });
          }
        },
        error: (err) => {
          this.loader.close();
          this.addedAssList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Vendor Associate Id": d.VendorAssociateId,
          "Name": d.Name,
          "AadharNo": d.AadharNo,
          "Mobile No": d.Mobile,
          "WorkType": d.WorkType,
          // "Photo": d.Photo,
          // "Signature": d.Signature,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'VendorAssociateId', header: 'Vendor Associate Id' },
      { field: 'Name', header: 'Name' },
      { field: 'AadharNo', header: 'Aadhar No' },
      { field: 'Mobile', header: 'Mobile No' },
      { field: 'WorkType', header: 'WorkType' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }

  onDeleteAddedAssRow(val) {
    if (val?.ApprovalStatus != 'Pending') {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Application already approved.',
      });
    }

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Do you want to remove ${val?.Name}?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        let reqBody = {
          VendorId: Number(this.vendorRegId),
          VendorAssociateId: Number(val?.VendorAssociateId)
        }

        this.deleteAssociateData(reqBody);
      },
      reject: () => {
        // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      },
    });
  }

  deleteAssociateData(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .deleteVendorAssociates(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          if (res == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Details submitted successfully.',
            });
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
          this.activityRecordService.activityRecord(this.userId, 'Vendor Associate Delete', this.userId, new Date(), `${res}`, JSON.stringify(reqBodyFinal));
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'Vendor Associate Delete(Error)', this.userId, new Date(), `${err}`, JSON.stringify(reqBodyFinal));
        },
      });
  }

  rowBackgroundColor(row) {
    if (row.ApprovalStatus == 'Pending') {
      return '#ff8080';
      // if (row.PendingCompletedDays <= -2) {
      // } else if (row.PendingCompletedDays == -1) {
      //   return '#ffc966';
      // }
    } else if (row.ApprovalStatus == 'Approved') {
      return '#99e699';
      // if (row.PendingCompletedDays >= -1) {
      // } else if (row.PendingCompletedDays <= -2) {
      //   return '#ffb3b3';
      // }
    } else return '#ffffff';
  }
}
